import { typographyClasses } from '@mui/material/Typography';
import { accordionClasses } from '@mui/material/Accordion';
import { accordionSummaryClasses } from '@mui/material/AccordionSummary';
// ----------------------------------------------------------------------
export function accordion(theme) {
    var _a, _b, _c;
    return {
        MuiAccordion: {
            styleOverrides: {
                root: (_a = {
                        backgroundColor: 'transparent'
                    },
                    _a["&.".concat(accordionClasses.expanded)] = {
                        boxShadow: theme.customShadows.z8,
                        borderRadius: theme.shape.borderRadius,
                        backgroundColor: theme.palette.background.paper
                    },
                    _a["&.".concat(accordionClasses.disabled)] = {
                        backgroundColor: 'transparent'
                    },
                    _a)
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: (_b = {
                        paddingLeft: theme.spacing(2),
                        paddingRight: theme.spacing(1)
                    },
                    _b["&.".concat(accordionSummaryClasses.disabled)] = (_c = {
                            opacity: 1,
                            color: theme.palette.action.disabled
                        },
                        _c["& .".concat(typographyClasses.root)] = {
                            color: 'inherit'
                        },
                        _c),
                    _b),
                expandIconWrapper: {
                    color: 'inherit'
                }
            }
        }
    };
}
